import { stringify } from 'query-string';
import { LanguageString, Pagination } from '../../../../../../../types/Common';
import { ConvoHistorySession } from '../../../../../../../types/ConversationHistory';
import { request } from '../../../../../../common/src/legacy/services/httpSessionService';

export const getConvoHistoryAll = async (
  params?: getConvoHistoryAllParamTypes,
): Promise<[ConvoHistorySessions, number]> => {
  const getQuery = params
    ? stringify(params, {
        skipEmptyString: true,
        skipNull: true,
      })
    : '';

  const path = `v1/api/conversations?${getQuery}`;
  const [resp, status] = await request({ path, origin });

  return [resp, status];
};

export interface ConvoHistorySessions {
  pagination: Pagination;
  items: ConvoHistorySession[];
}

export interface getConvoHistoryAllParamTypes {
  created_at_ge?: string;
  created_at_le?: string;
  modified_at_ge?: string;
  modified_at_le?: string;
  status?: string;
  party_id?: string[];
  origin?: string[];
  order_by?: string;
  sort?: string;
  lang?: LanguageString;
  page?: number;
  pagelen?: number;
  flow_id?: string;
  q?: string;
}
